package core.utils

import kotlinx.datetime.*

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 06.02.21
 * Author : leonhergt
 */
class TimeUtils {

    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Internal properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    fun getCurrentTimestamp(): Long {
        return Clock.System.now().toEpochMilliseconds()
    }

    fun timeMillisToDateTimeString(currentTimeZone: Long?): String {
        val dateTime = dateTimeFromMillis(currentTimeZone ?: 0)
        return "${dateTime.toSimpleDateString()} ${dateTime.toSimpleTimeString()}"
    }

    fun timeMillisToDateString(currentTimeZone: Long?): String {
        val dateTime = dateTimeFromMillis(currentTimeZone ?: 0)
        return dateTime.toSimpleDateString()
    }

    fun timeMillisToExtendedDateString(currentTimeZone: Long?): String {
        val dateTime = dateTimeFromMillis(currentTimeZone ?: 0)
        return "${dateTime.toShortDayDescription()} ${dateTime.toSimpleDateString()}"
    }

    fun timeMillisToTimeString(currentTimeZone: Long?): String {
        val dateTime = dateTimeFromMillis(currentTimeZone ?: 0)
        return dateTime.toSimpleTimeString()
    }

    fun timeMillisToVoiceAssistantString(timeMillis: Long?, convertWithTime: Boolean): String {
        val dateTime = dateTimeFromMillis(timeMillis ?: 0)
        return if (convertWithTime) {
            "${dateTime.toSimpleDateString()} ${dateTime.toSimpleTimeString()}"
        } else {
            dateTime.toSimpleDateString()
        }
    }

    fun currentYear(): Int {
        return dateTimeFromMillis(getCurrentTimestamp()).year
    }

    fun generateTimestampForICSFormat(timeMillis: Long): String{
        val dateTime = dateTimeFromMillis(timeMillis)
        return "${dateTime.year}${dateTime.monthNumber.twoDigits()}${dateTime.dayOfMonth.twoDigits()}T${dateTime.hour.twoDigits()}${dateTime.minute.twoDigits()}${dateTime.second.twoDigits()}Z"
    }

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    private fun dateTimeFromMillis(timeMillis: Long?): LocalDateTime {
        val instant = Instant.fromEpochMilliseconds(timeMillis ?: 0L)
        return instant.toLocalDateTime(TimeZone.currentSystemDefault())
    }
    private fun LocalDateTime.toSimpleDateString(): String {
        return "${this.dayOfMonth.twoDigits()}.${this.monthNumber.twoDigits()}.${this.year}"
    }

    private fun LocalDateTime.toSimpleTimeString(): String {
        return "${this.hour.twoDigits()}:${this.minute.twoDigits()}"
    }

    private fun LocalDateTime.toShortDayDescription(): String {
        return when (this.dayOfWeek) {
            DayOfWeek.MONDAY -> "Mo."
            DayOfWeek.TUESDAY -> "Di."
            DayOfWeek.WEDNESDAY -> "Mi."
            DayOfWeek.THURSDAY -> "Do."
            DayOfWeek.FRIDAY -> "Fr."
            DayOfWeek.SATURDAY -> "Sa."
            DayOfWeek.SUNDAY -> "So."
            else -> ""
        }
    }

    private fun Int.twoDigits() = if (this >= 10) this.toString() else "0$this"

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------

}